// Examples:
//  const debouncedSearch = debounce(handleSearch, 500);

export function debounce(func, wait) {
  let timeout;
  return function (...args) {
    if(timeout) clearTimeout(timeout);

    timeout = setTimeout(() => {
      func(...args);
    }, wait);
  };
}
